import { render, staticRenderFns } from "./inquiryDetail.vue?vue&type=template&id=38e04add&scoped=true&"
import script from "./inquiryDetail.vue?vue&type=script&lang=js&"
export * from "./inquiryDetail.vue?vue&type=script&lang=js&"
import style0 from "./inquiryDetail.vue?vue&type=style&index=0&id=38e04add&lang=less&scoped=true&"
import style1 from "./inquiryDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e04add",
  null
  
)

component.options.__file = "inquiryDetail.vue"
export default component.exports